import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/main.css";
import router from './router'
import InitData from "@/util/InitData";
import TimeUtil from "@/util/TimeUtil";
import BreadcrumbUtil from "@/util/BreadcrumbUtil";
import ScreenCalaUtil from "@/util/ScreenCalaUtil";

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$initData = InitData;
Vue.prototype.$timeUtil = TimeUtil;
Vue.prototype.$breadcrumbUtil = BreadcrumbUtil;
Vue.prototype.$screenCalaUtil = ScreenCalaUtil;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
